module.exports = __webpack_public_path__ + "static/media/LIBS_FULL LOGO_GREEN.34e58e1f.png";